import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { DealershipsEntities } from 'client/data/models/dealerships';
import { DealerCard } from 'site-modules/dealerships/components/dealer-card/dealer-card';

export class DealersCardsList extends PureComponent {
  static propTypes = {
    dealers: PropTypes.arrayOf(DealershipsEntities.Dealer),
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    dealers: [],
    isMobile: false,
  };

  componentDidMount() {
    this.fireListPixel();
  }

  componentDidUpdate() {
    this.fireListPixel();
  }

  fireListPixel = () => {
    const { dealers } = this.props;

    if (dealers.length) {
      EventToolbox.fireTrackAction({
        event_type: 'action_completed',
        event_data: {
          action_name: TrackingConstant.ACTION_LIST,
          action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
          action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
          creative_id: 'edm-entry-dealer-card-list',
          loc_id_list: dealers.map(dealer => dealer.rooftopId).join(','),
        },
      });
    }
  };

  render() {
    const { dealers, isMobile } = this.props;

    return (
      <ul className="dealerships-list list-unstyled mb-1_5" data-tracking-parent="edm-entry-dealer-card-list">
        {dealers.map(dealer => (
          <DealerCard dealer={dealer} key={dealer.id} isMobile={isMobile} />
        ))}
      </ul>
    );
  }
}
